import React, { createContext, useState, useContext } from 'react';

interface BreadcrumbNameContextType {
  breadcrumbName?: string;
  setBreadcrumbName: (name?: string) => void;
}

export const BreadcrumbNameContext = createContext<BreadcrumbNameContextType>({
  breadcrumbName: undefined,
  setBreadcrumbName: () => {},
});

export const BreadcrumbNameProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [breadcrumbName, setBreadcrumbName] = useState<string | undefined>(undefined);
  return (
    <BreadcrumbNameContext.Provider value={{ breadcrumbName, setBreadcrumbName }}>
      {children}
    </BreadcrumbNameContext.Provider>
  );
};

export const useBreadcrumbName = () => useContext(BreadcrumbNameContext);
